import * as betgalaxy from './FormControl.styles.betgalaxy';
import * as betprofessor from './FormControl.styles.betprofessor';
import * as betroyale from './FormControl.styles.betroyale';
import * as fiestabet from './FormControl.styles.fiestabet';
import * as puntcity from './FormControl.styles.puntcity';
import * as puntgenie from './FormControl.styles.puntgenie';
import * as questbet from './FormControl.styles.questbet';
import * as sterlingparker from './FormControl.styles.sterlingparker';
import * as vikingbet from './FormControl.styles.vikingbet';
import * as volcanobet from './FormControl.styles.volcanobet';
import * as wellbet from './FormControl.styles.wellbet';
import * as goldenrush from './FormControl.styles.goldenrush';
import * as juicybet from './FormControl.styles.juicybet';
import * as forsport from './FormControl.styles.forsport';
import * as junglebet from './FormControl.styles.junglebet';
import * as sugarcastle from './FormControl.styles.sugarcastle';
import * as buffalobet from './FormControl.styles.buffalobet';
import * as oldgill from './FormControl.styles.oldgill';
import * as titanbet from './FormControl.styles.titanbet';
import * as gigabet from './FormControl.styles.gigabet';
import * as slambet from './FormControl.styles.slambet';
import * as betstride from './FormControl.styles.betstride';
import * as templebet from './FormControl.styles.templebet';
import * as goldenbet888 from './FormControl.styles.goldenbet888';
import * as hyperbet from './FormControl.styles.hyperbet';
import * as bet777 from './FormControl.styles.bet777';
import * as chromabet from './FormControl.styles.chromabet';
import * as bet575 from './FormControl.styles.bet575';
import * as epicodds from './FormControl.styles.epicodds';
import * as pyramidbet from './FormControl.styles.pyramidbet';
import * as magnumbet from './FormControl.styles.magnumbet';

import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  oldgill,
  betgalaxy,
  betprofessor,
  betroyale,
  fiestabet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  goldenrush,
  juicybet,
  forsport,
  junglebet,
  sugarcastle,
  buffalobet,
  titanbet,
  gigabet,
  slambet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  epicodds,
  pyramidbet,
  magnumbet,
};
